export const GENERAL_PATH = {
  ORDER: '/general/order',
  DELIVERY: '/general/delivery',
  SCHEDULE: '/general/schedule',
};
